module.exports = __webpack_public_path__ + "img/nohem.c1bd03e5.png";